<div class="angular-editor" #angularEditor [style.width]="config.width"
     [style.minWidth]="config.minWidth">
  <angular-editor-toolbar *ngIf="config.toolbarPosition === 'top' " #editorToolbar
                          (execute)="executeCommand($event)"></angular-editor-toolbar>

  <div class="angular-editor-wrapper" #editorWrapper>
    <div #editor class="angular-editor-textarea" [attr.contenteditable]="config.editable"
         [attr.tabintex]="disabled ? -1 : tabIndex"
         [attr.translate]="config.translate"
         [attr.spellcheck]="config.spellcheck" [style.height]="config.height" [style.minHeight]="config.minHeight"
         [style.maxHeight]="config.maxHeight"
         (input)="onContentChange($event.target.innerHTML)"
         (focus)="onTextAreaFocus($event)"
         (blur)="onTextAreaBlur($event)"
         (click)="exec()"
         (keyup)="exec()"
         (mouseout)="onTextAreaMouseOut($event)"
    >
    </div>
    <span class="angular-editor-placeholder">{{ placeholder || config['placeholder'] }}</span>
  </div>
  <angular-editor-toolbar *ngIf="config.toolbarPosition === 'bottom'" #editorToolbar
                          (execute)="executeCommand($event)"></angular-editor-toolbar>
</div>
